module.exports = __webpack_public_path__ + "media/images/icons/icons_large/9_dress-f7be77f1b70efc1881f865f4c108e272.png";